const $ = jQuery.noConflict();

const accordionCarousel = () => {
	$('.block-accordion-carousel .bellow__title').on('click', function(event) {
		$('.block-accordion-carousel .bellow.active .bellow__content').stop().slideToggle(250);
		$('.block-accordion-carousel .bellow').removeClass('active');
		$(this).parent().addClass('active');
		$(this).next().stop().slideToggle(250);
	});
}

// GLOBAL APP CONTROLLER
const controller = {
	init() {},
	loaded() {
		accordionCarousel();
	},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
